import './tailwind.css';
import 'swiper/css';
import 'swiper/css/pagination';
import Lenis from '@studio-freight/lenis';
import GLightbox from 'glightbox';
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'

Alpine.plugin(collapse)

// Case Studies Filter Component
Alpine.data('caseStudiesFilter', () => ({
    loading: false,

    async search() {
        const propertyType = document.getElementById('property-type')?.value || '';
        const location = document.getElementById('location')?.value || '';

        this.loading = true;

        try {
            const formData = new FormData();
            formData.append('action', 'filter_case_studies');
            formData.append('property_type', propertyType);
            formData.append('location', location);
            formData.append('nonce', window.caseStudiesAjax?.nonce || '');

            const response = await fetch(window.caseStudiesAjax?.ajaxUrl || '/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (data.success) {
                const grid = document.getElementById('case-studies-grid');
                if (grid) {
                    grid.innerHTML = data.data.html;
                }
            } else {
                console.error('Filter error:', data.data?.message);
            }
        } catch (error) {
            console.error('AJAX error:', error);
        } finally {
            this.loading = false;
        }
    }
}));

window.Alpine = Alpine
Alpine.start()

document.addEventListener('DOMContentLoaded', () => {
    console.log('Global modals ready');

    function initContactForm7Forms(scope = document) {
        if (!window.wpcf7 || typeof window.wpcf7.init !== 'function') {
            return;
        }

        scope.querySelectorAll('.wpcf7 > form.wpcf7-form').forEach((form) => {
            if (form.wpcf7) {
                return;
            }

            const formId = Number.parseInt(new FormData(form).get('_wpcf7'), 10);
            const schema = window.wpcf7.schemas?.get(formId);

            window.wpcf7.init(form);
            if (schema && window.wpcf7.schemas) {
                window.wpcf7.schemas.set(formId, schema);
            }

            form.closest('.wpcf7')?.classList.replace('no-js', 'js');
        });
    }

    function isGlobalModalHash(hash) {
        if (!hash || hash === '#') {
            return false;
        }

        return Array.from(document.querySelectorAll('[data-glightbox-global][href^="#"]')).some((link) => (
            link.getAttribute('href') === hash
        ));
    }

    // Initialize the global lightbox instance
    const globalModal = GLightbox({
        selector: '[data-glightbox-global]',
        touchNavigation: false,
        closeOnOutsideClick: true,
        keyboardNavigation: true,
        loop: false,
        afterSlideLoad: ({ slide }) => {
            initContactForm7Forms(slide);
        },
    });

    // Utility: open a modal by URL hash
    function openModalByHash() {
        const hash = window.location.hash;
        if (!isGlobalModalHash(hash)) return;

        // Reload GLightbox in case modals were injected dynamically
        globalModal.reload();

        const target = document.querySelector(hash);
        if (target) {
            globalModal.open({
                href: hash,
                type: 'inline',
            });
        }
    }

    // Try opening on page load
    setTimeout(openModalByHash, 300); // slight delay helps if HubSpot loads content async

    // Listen for hash changes
    window.addEventListener('hashchange', openModalByHash);

    // Custom in-modal close button (the modal's own "x", not GLightbox's default chrome)
    document.addEventListener('click', (event) => {
        if (event.target.closest('[data-sg-modal-close]')) {
            event.preventDefault();
            globalModal.close();
        }
    });
});

function initLenis() {
    // Respect reduced motion
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const lenis = new Lenis({
        smoothWheel: !prefersReduced,   // optional
        smoothTouch: !prefersReduced,   // optional
        duration: 1.1,                  // tweak to taste
        // easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        // wheelMultiplier: 1,
        // touchMultiplier: 1.2,
        // orientation: 'vertical',
    });

    // RAF loop
    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // Optional: smooth scroll for in-page anchors with header offset
    const header = document.querySelector('[data-sticky-header]');
    const offset = header ? -header.offsetHeight : 0;

    document.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener('click', (e) => {
            if (link.hasAttribute('data-glightbox-global') || link.hasAttribute('data-ares-nav-link') || link.closest('[data-ares-section-menu]')) {
                return;
            }

            const id = link.getAttribute('href');
            if (!id || id === '#') return;
            const target = document.querySelector(id);
            if (!target) return;

            e.preventDefault();
            lenis.scrollTo(target, { offset, lock: true });
        });
    });

    // Expose for debugging if you like
    window.lenis = lenis;
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLenis);
} else {
    initLenis();
}


// global JS
async function initAOS() {
    // AOS.init() is already called with disable: 'mobile' below, so on phones it
    // downloads and runs only to immediately turn itself off. Skip the fetch and
    // init entirely under the site's mobile breakpoint — same end result, no
    // wasted script evaluation. (This uses viewport width, matching how "mobile"
    // is defined everywhere else in this theme; AOS's own disable:'mobile' check
    // is user-agent based, so the two can disagree in rare edge cases like a
    // narrow desktop window or a phone in landscape — not a functional break,
    // just an animation running or not in that edge case.)
    if (window.matchMedia('(max-width: 767px)').matches) return;

    try {
        const { default: AOS } = await import('aos');   // npm i aos
        await import('aos/dist/aos.css');               // include AOS css
        AOS.init({ duration: 1000, once: false, disable: 'mobile' });
    } catch (e) { /* aos not installed — ignore */ }
}

// Background <video> elements (e.g. the hero) mark themselves with
// data-lazy-video and put their real URL on <source data-src="...">
// instead of src. On mobile, the browser doesn't start fetching until the
// rest of the page (including images) has finished loading — that's the
// expensive case worth deferring. On desktop there's more bandwidth/CPU
// headroom and no Lighthouse-mobile pressure, so it loads immediately
// instead of waiting. Plays on every device either way, just a different
// start time. A video can have more than one <source> (e.g. a
// mobile-specific cut scoped with media="(max-width:767px)" ahead of the
// desktop one) — all of them need their real src set before .load() so
// the browser can evaluate each source's media query and pick the right one.
// A video can also carry data-mobile-poster for a mobile-specific poster —
// the native poster attribute can't do responsive switching on its own.
function initLazyVideos() {
    const videos = Array.from(document.querySelectorAll('[data-lazy-video]'));
    if (!videos.length) return;

    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    // Poster swap runs immediately (not deferred like the source below) so the
    // right poster is showing from the start, instead of the desktop one
    // flashing first and then getting swapped out.
    if (isMobile) {
        videos.forEach((video) => {
            if (video.dataset.mobilePoster) {
                video.poster = video.dataset.mobilePoster;
            }
        });
    }

    const loadVideos = () => {
        videos.forEach((video) => {
            const sources = Array.from(video.querySelectorAll('source[data-src]'));
            if (!sources.length) return;

            sources.forEach((source) => {
                source.src = source.dataset.src;
                source.removeAttribute('data-src');
            });
            video.load();
            video.play().catch(() => { /* autoplay blocked — poster stays visible */ });
        });
    };

    if (!isMobile) {
        loadVideos();
        return;
    }

    if (document.readyState === 'complete') {
        loadVideos();
    } else {
        window.addEventListener('load', loadVideos, { once: true });
    }
}

// Utils
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const mq1199 = window.matchMedia('(max-width: 1199px)');
const mq787 = window.matchMedia('(max-width: 787px)');

function setMaxHeight(el, px) {
    if (!el) return;
    if (el.classList?.contains('sg-nav__submenu')) {
        el.style.maxHeight = '';
        return;
    }
    el.style.maxHeight = (px == null ? '' : px + 'px');
}

function closeAll(selectorItem, selectorContent) {
    $$(selectorItem).forEach(item => {
        item.classList.remove('active', 'open');
        const c = item.querySelector(selectorContent);
        if (c) setMaxHeight(c, 0);
    });
}

// Drop items (.drop-item -> .hidden-content)
function enableDropItems() {
    $$('.drop-item').forEach(item => {
        if (item.__bound) return;
        item.__bound = true;
        item.addEventListener('click', (e) => {
            if (e.target.closest('a')) return; // allow links inside
            e.preventDefault();
            const isActive = item.classList.contains('active');
            const content = item.querySelector('.hidden-content');
            closeAll('.drop-item', '.hidden-content');
            if (!isActive && content) {
                item.classList.add('active');
                setMaxHeight(content, content.scrollHeight);
            }
        });
    });
}
function resetDropItems() {
    closeAll('.drop-item', '.hidden-content');
    $$('.hidden-content').forEach(c => { c.style.maxHeight = ''; });
}

// Header dropdown boxes (.dropdown-box -> .option-list, uses --option-list-height)
function initHeaderDropdowns() {
    $$('.dropdown-box').forEach(box => {
        if (box.__bound) return;
        box.__bound = true;
        box.addEventListener('click', (e) => {
            e.stopPropagation();
            const list = box.querySelector('.option-list');
            const isOpen = box.classList.contains('open');
            if (isOpen) {
                box.classList.remove('open');
                box.style.setProperty('--option-list-height', '0px');
            } else if (list) {
                const h = list.scrollHeight;
                box.style.setProperty('--option-list-height', h + 'px');
                box.classList.add('open');
            }
        });
    });

    // Click outside to close header dropdowns and mobile menu
    document.addEventListener('click', (e) => {
        if (!e.target.closest('.dropdown-box, #mobile-menu-icon, .mobile-menu, .menu-item-has-children')) {
            $$('.dropdown-box').forEach(b => {
                b.classList.remove('open');
                b.style.setProperty('--option-list-height', '0px');
            });
            $('#mobile-menu-icon')?.classList.remove('open');
            $('.mobile-menu')?.classList.remove('open-menu');
            document.body.classList.remove('open-mobile-menu');
            $$('.sub-menu').forEach(ul => setMaxHeight(ul, 0));
            $$('.menu-item-has-children').forEach(li => li.classList.remove('open'));
        }
    });
}

// Mobile menu
function initMobileMenu() {
    const icon = $('#mobile-menu-icon');
    const menu = $('.mobile-menu');
    if (!icon || !menu) return;

    icon.addEventListener('click', (e) => {
        e.stopPropagation();
        const open = icon.classList.toggle('open');
        menu.classList.toggle('open-menu', open);
        document.body.classList.toggle('open-mobile-menu', open);
    });

    // Nav items with children (click to toggle — ignore link clicks)
    $$('.menu-item-has-children').forEach(item => {
        if (item.__bound) return;
        item.__bound = true;
        item.addEventListener('click', (e) => {
            if (e.target.closest('a')) return;
            e.preventDefault();
            e.stopPropagation();
            const submenu = item.querySelector('.sub-menu');
            const willOpen = !item.classList.contains('open');

            // close others
            $$('.menu-item-has-children.open').forEach(openItem => {
                openItem.classList.remove('open');
                const sm = openItem.querySelector('.sub-menu');
                if (sm) setMaxHeight(sm, 0);
            });

            // toggle this
            item.classList.toggle('open', willOpen);
            if (submenu) setMaxHeight(submenu, willOpen ? submenu.scrollHeight : 0);
        });
    });
}

// Footer mobile dropdowns (.mobile-dropdown h5 -> .hidden-content)
function initFooterDropdowns() {
    $$('.mobile-dropdown h5').forEach(h => {
        if (h.__bound) return;
        h.__bound = true;
        h.addEventListener('click', () => {
            if (!mq787.matches) return;
            const parent = h.closest('.mobile-dropdown');
            const content = parent?.querySelector('.hidden-content');
            const willOpen = !content?.classList.contains('open');

            // close all
            $$('.mobile-dropdown .hidden-content.open').forEach(c => {
                c.classList.remove('open');
                setMaxHeight(c, 0);
            });
            $$('.mobile-dropdown h5.open').forEach(h5 => h5.classList.remove('open'));

            if (content) {
                content.classList.toggle('open', willOpen);
                setMaxHeight(content, willOpen ? content.scrollHeight : 0);
                h.classList.toggle('open', willOpen);
            }
        });
    });
}

// Active link highlighting
function markActiveLinks() {
    const here = window.location.origin + window.location.pathname.replace(/\/+$/, '/');
    $$('a[href]').forEach(a => {
        try {
            const url = new URL(a.href, window.location.origin);
            const norm = url.origin + url.pathname.replace(/\/+$/, '/');
            if (norm === here) a.classList.add('active-link');
        } catch { }
    });
}

function initSpringGroveShell() {
    const header = document.querySelector('[data-sg-site-header]');
    if (!header) return;

    const mobileToggle = header.querySelector('[data-sg-mobile-toggle]');
    const mobileMenu = document.querySelector('[data-sg-mobile-menu]');
    const submenuToggles = Array.from(document.querySelectorAll('[data-sg-submenu-toggle]'));
    const desktopHeroNavQuery = window.matchMedia('(min-width: 1181px)');
    let shellStoppedLenis = false;
    let mobileScrollLockState = null;

    const syncHeaderOffset = () => {
        const offset = Math.round(header.getBoundingClientRect().bottom);
        document.documentElement.style.setProperty('--sg-header-offset', `${offset}px`);
    };

    syncHeaderOffset();
    window.addEventListener('resize', syncHeaderOffset);
    window.addEventListener('orientationchange', syncHeaderOffset);
    if ('ResizeObserver' in window) {
        new ResizeObserver(syncHeaderOffset).observe(header);
    }

    const setMobileScrollLock = (locked) => {
        document.documentElement.classList.toggle('sg-mobile-menu-open', locked);
        document.body.classList.toggle('sg-mobile-menu-open', locked);

        if (locked && !mobileScrollLockState) {
            mobileScrollLockState = {
                scrollY: window.scrollY || document.documentElement.scrollTop || 0,
                bodyPosition: document.body.style.position,
                bodyTop: document.body.style.top,
                bodyLeft: document.body.style.left,
                bodyRight: document.body.style.right,
                bodyWidth: document.body.style.width,
            };

            document.body.style.position = 'fixed';
            document.body.style.top = `-${mobileScrollLockState.scrollY}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.width = '100%';
        }

        if (!locked && mobileScrollLockState) {
            const { scrollY, bodyPosition, bodyTop, bodyLeft, bodyRight, bodyWidth } = mobileScrollLockState;

            document.body.style.position = bodyPosition;
            document.body.style.top = bodyTop;
            document.body.style.left = bodyLeft;
            document.body.style.right = bodyRight;
            document.body.style.width = bodyWidth;
            window.scrollTo(0, scrollY);
            mobileScrollLockState = null;
        }

        const lenis = window.lenis;
        if (!lenis || typeof lenis.stop !== 'function' || typeof lenis.start !== 'function') {
            return;
        }

        if (locked && !lenis.isStopped) {
            lenis.stop();
            shellStoppedLenis = true;
            return;
        }

        if (!locked && shellStoppedLenis) {
            lenis.start();
            shellStoppedLenis = false;
        }
    };

    const closeSubmenus = (scope = document) => {
        scope.querySelectorAll('[data-sg-submenu-toggle][aria-expanded="true"]').forEach((toggle) => {
            toggle.setAttribute('aria-expanded', 'false');
            const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
            if (submenu) {
                submenu.hidden = true;
            }
            toggle.closest('[data-sg-menu-item]')?.classList.remove('is-open');
        });
    };

    const setStickyHeaderHidden = (hidden) => {
        header.classList.toggle('sg-site-header--hero-nav-active', hidden);
        if (hidden) {
            closeSubmenus(header);
            header.setAttribute('aria-hidden', 'true');
            header.inert = true;
            return;
        }

        header.removeAttribute('aria-hidden');
        header.inert = false;
    };

    const initSpringGroveHeroNavReveal = () => {
        const heroNav = document.querySelector('[data-sg-hero-nav]');
        if (!heroNav || header.dataset.sgHeaderReveal !== 'enabled') {
            setStickyHeaderHidden(false);
            return;
        }

        const syncHeaderState = () => {
            if (!desktopHeroNavQuery.matches) {
                setStickyHeaderHidden(false);
                return;
            }

            const rect = heroNav.getBoundingClientRect();
            setStickyHeaderHidden(rect.bottom > 0 && rect.top < window.innerHeight);
        };

        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries) => {
                const entry = entries[0];
                setStickyHeaderHidden(desktopHeroNavQuery.matches && entry.isIntersecting);
            }, {
                root: null,
                threshold: 0,
            });

            observer.observe(heroNav);
        }

        syncHeaderState();
        window.addEventListener('scroll', syncHeaderState, { passive: true });
        window.addEventListener('resize', syncHeaderState);
        desktopHeroNavQuery.addEventListener('change', syncHeaderState);
    };

    const closeMobileMenu = () => {
        if (!mobileToggle || !mobileMenu) return;
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileToggle.classList.remove('is-open');
        mobileMenu.hidden = true;
        setMobileScrollLock(false);
        closeSubmenus(mobileMenu);
    };

    submenuToggles.forEach((toggle) => {
        toggle.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
            if (!submenu) return;

            const menu = toggle.closest('.sg-nav');
            const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
            if (menu) {
                closeSubmenus(menu);
            }

            toggle.setAttribute('aria-expanded', String(willOpen));
            submenu.hidden = !willOpen;
            toggle.closest('[data-sg-menu-item]')?.classList.toggle('is-open', willOpen);
        });
    });

    if (mobileToggle && mobileMenu) {
        mobileToggle.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const willOpen = mobileToggle.getAttribute('aria-expanded') !== 'true';
            if (willOpen) {
                syncHeaderOffset();
                mobileToggle.setAttribute('aria-expanded', 'true');
                mobileToggle.classList.add('is-open');
                mobileMenu.hidden = false;
                setMobileScrollLock(true);
            } else {
                closeMobileMenu();
            }
        });
    }

    document.addEventListener('click', (event) => {
        if (header.contains(event.target) || (mobileMenu && mobileMenu.contains(event.target)) || event.target.closest('[data-sg-hero-nav]')) return;
        closeSubmenus();
        closeMobileMenu();
    });

    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const wasMobileOpen = mobileToggle?.getAttribute('aria-expanded') === 'true';
        closeSubmenus();
        closeMobileMenu();
        if (wasMobileOpen) {
            mobileToggle?.focus();
        }
    });

    window.addEventListener('resize', () => {
        if (window.matchMedia('(min-width: 1024px)').matches) {
            closeMobileMenu();
        }
    });

    initSpringGroveHeroNavReveal();
}

// Search overlay (#search-overlay with .search-overlay-close)
function initSearchOverlay() {
    const trigger = document.querySelector('.header-right a[href="#"]');
    const overlay = document.getElementById('search-overlay');
    const closeBtn = document.querySelector('.search-overlay-close');
    if (!trigger || !overlay || !closeBtn) return;
    trigger.addEventListener('click', (e) => { e.preventDefault(); overlay.classList.add('open'); });
    closeBtn.addEventListener('click', () => overlay.classList.remove('open'));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') overlay.classList.remove('open'); });
}

// Apply drop-item behaviour only under 1200px (matches your original)
function applyDropItemsByViewport() {
    if (mq1199.matches) enableDropItems(); else resetDropItems();
}

// Shrinks .spring-grove-hero__heading only if it actually overflows its
// .spring-grove-hero__content box — CSS alone can only guess at the real
// text width, so this measures scrollWidth vs the container's clientWidth
// and steps the font down just far enough to fit, instead of scaling every
// heading down to cover the longest possible case.
function fitHeroHeadings() {
    document.querySelectorAll('.spring-grove-hero__heading').forEach((heading) => {
        const container = heading.closest('.spring-grove-hero__content');
        if (!container) return;

        heading.style.removeProperty('font-size');

        const maxWidth = container.clientWidth;
        if (maxWidth <= 0 || heading.scrollWidth <= maxWidth) return;

        let fontSize = parseFloat(window.getComputedStyle(heading).fontSize);
        const minFontSize = 18;

        while (heading.scrollWidth > maxWidth && fontSize > minFontSize) {
            fontSize -= 1;
            heading.style.fontSize = `${fontSize}px`;
        }
    });
}

function initHeroHeadingFit() {
    if (!document.querySelector('.spring-grove-hero__heading')) return;

    let frame = null;
    const scheduleFit = () => {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(fitHeroHeadings);
    };

    scheduleFit();
    window.addEventListener('resize', scheduleFit);

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(scheduleFit).catch(() => {});
    }
}

document.addEventListener('DOMContentLoaded', () => {
    //initLenis();
    initAOS();
    initLazyVideos();

    initHeaderDropdowns();
    initMobileMenu();
    initFooterDropdowns();
    initSearchOverlay();
    initSpringGroveShell();
    initHeroHeadingFit();
    markActiveLinks();

    applyDropItemsByViewport();
    mq1199.addEventListener('change', applyDropItemsByViewport);
});
